<template>
<div>
    <submission-title
        v-if="!hide_title"
        :form_status="form_submission.form_status"
    />

    <submission-subtitle :form_status="form_submission.form_status" />

    <tool-certificate-content :certificate="certificate ?? form_submission?.certificate" />
</div>
</template>

<script>
import GalleryViewComponent from '../general_components/GalleryViewComponent';
import ToolCertificateContent from '../people/ToolCertificateContent';
import SubmissionTitle from '../submissions/SubmissionTitle';
import SubmissionSubtitle from './SubmissionSubtitle.vue';

export default {
    name: 'HavsToolsSubmission',
    components: {
        GalleryViewComponent,
        SubmissionTitle,
        SubmissionSubtitle,
        ToolCertificateContent,
    },
    props: {
        form_submission: {
            type: Object,
            required: false,
        },
        certificate: {
            type: Object,
            required: false,
        },
        hide_title: Boolean,
    },
};
</script>
